import React, { useState } from 'react'
import { FaThLarge, FaEnvelope, FaBookOpen, FaStamp, FaTable, FaCalculator, FaHouseUser, FaNewspaper, FaFile, FaAngleRight, FaLaptop, FaPowerOff, FaMoneyCheck, FaRegCalendar, FaBars, FaTimes } from 'react-icons/fa'
import AvatarProfile from './AvatarProfile'
import Axios from 'axios'
import { createReferenceID } from '../_utils'

import "./Navbar.css"
import NITALogo from '../_images/nita-itco-combo.png'
import { SidebarData as menu, clientMenu } from './SidebarData'

export default function Navbar() {
  const [ sidebar, setSidebar ] = useState( false )
  const showSidebar = () => setSidebar( !sidebar )
  const [ openSubMenu, setSubMenu ] = useState( true )

  const handleToggle = () => {
    setSubMenu( !openSubMenu )
  } 

  const handlePress = async ( slug ) => {
    await localStorage.setItem( "name", slug )
    return window.location.reload()
  }

  const handleDisplayRole = role => {
    switch( role?.toUpperCase() ) {
        case "AUDITOR":
            return "AUDITING AUTHORITY"
        case "SECURITY":
            return "SECURITY"
        case "QA1":
        case "QA2":
        case "QA3":
            return "QUALITY ASSURANCE AUTHORITY"
        case "VERIFIER":
            return "VERIFYING AUTHORITY"
        case "FINANCE":
            return "FINANCE TEAM"
        case "APPROVER":
            return "APPROVING AUTHORITY"
        case "APPLICANT":
            return "CLIENT"
        default:
            return
    }
  }

  const handleLogout = async () => {
    let ugpass = await localStorage.getItem( "ugpass_access" )
    if( ugpass ) {
        logoutUgPass()
    }
    else {
        await localStorage.clear()
        window.location.reload()
    }
  }

  const logoutUgPass = async () => {
    let access = JSON.parse( localStorage.getItem( "accessToken" ) )
    
    let baseUrl = `https://api.ugpass.go.ug/idp` 
    let logoutUrl = `https://cert.works.go.ug`
    let state = createReferenceID( 12 )
    
    try {
        const response  = await Axios.get( `${baseUrl}/OIDClogout?id_token_hint=${access?.id_token}&post_logout_redirect_uri=${logoutUrl}&state=${state}` )
        // console.log( response.data )
        await localStorage.clear()
        window.location.reload()
    } catch (error) {
        // console.error( error )
        await localStorage.clear()
        window.location.reload()
    }
    
  }

  return (
    <>
        <nav className="sticky top-0 z-50 md:h-20 lg:h-20 h-16 flex items-center justify-between bg-white shadow-md">
            <div className="h-full grid grid-cols-1 py-2 w-[130px] md:w-[250px] lg:w-[250px] bg-[#AFC836]">
                <div className="flex items-center justify-center px-2 relative">
                    <button
                        type="button"
                        className="absolute left-2 md:hidden"
                        onClick={showSidebar}
                        aria-label="Open navigation menu"
                    >
                        <FaBars size={18} color={`#222`} />
                    </button>
                    <img src={NITALogo} />
                </div>
                {/* <div className="px-2 flex items-center justify-center">
                    <span className="text-xs text-black font-bold">
                        {`I.T Certification Office`}
                    </span>
                </div> */}
            </div>
            <div className="px-2 flex items-center">
                <div className="flex flex-col items-center justify-center">
                    {/* <div className=" border border-red-500 text-xs text-start text-gray-500 mx-2 font-bold p-1">
                        {handleDisplayRole( localStorage.getItem( "role" ) )}
                    </div> */}
                    <AvatarProfile label={`${localStorage.getItem( "username" )}`} />
                    <span className="text-[10px] md:text-xs text-center">{`${handleDisplayRole( localStorage.getItem( "role" ) )}`}</span>
                </div>
                <div className="hidden sm:block">
                    <LinkDesk />
                </div>
                <div className="px-2 md:px-5 cursor-pointer">
                    <FaPowerOff onClick={ async() => {
                        handleLogout()
                    } } size={14} color={`red`} />
                </div>
            </div>
        </nav>
        {sidebar && <div className="fixed inset-0 bg-black/30 z-40 md:hidden" onClick={showSidebar} />}
        <aside className={`flex flex-col h-full w-[260px] md:w-[250px] lg:w-[250px] bg-gray-50 fixed z-50 md:z-30 shadow-md top-16 md:top-20 transition-transform duration-300 ${sidebar ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}>
          <div className="w-full h-12 flex items-center justify-between px-3 bg-white md:hidden">
            <span className="text-xs text-gray-500 uppercase">Navigation</span>
            <button type="button" onClick={showSidebar} aria-label="Close navigation menu">
                <FaTimes size={16} color={`#666`} />
            </button>
          </div>
          <div className="w-full h-14 grid grid-rows-2 bg-white">
            <div />
            <div>
                <span className="flex-end text-xs text-gray-400 uppercase">
                    {`Navigation`}
                </span>
            </div>
          </div>
          <div className="w-full h-auto flex flex-col">
            <div className="w-full h-full flex flex-col">
                {localStorage.getItem( "role" ) !== "APPLICANT" ? (
                    <>
                        {!localStorage.getItem( "role" )?.toUpperCase().includes("FINANCE") ? (
                            <>
                                {
                                    menu
                                    .filter(item => item.role.includes(localStorage.getItem("role")?.toUpperCase()))
                                    .map((item, index) => (
                                        <SidebarLink key={index} item={item} active={localStorage.getItem("link") === item.slug} closeSidebar={() => setSidebar(false)} />
                                    ))
                                }
                            </>
                        ) : (
                            <>
                                <MenuItemLink slug="finance" label="Finance" spaced icon={<FaMoneyCheck size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                                <MenuItemLink slug="non_ura_payments" label="Clear Payment Manually" spaced icon={<FaMoneyCheck size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                                <MenuItemLink slug="generated_prns" label="View Generated PRNs" spaced icon={<FaMoneyCheck size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                            </>
                        )}
                    </>
                ) : (
                    <>
                        <MenuItemLink slug="welcome" label="My Applications" spaced icon={<FaEnvelope size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                        <MenuItemLink slug="payments" label="My Payments" spaced icon={<FaMoneyCheck size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                        <MenuItemLink slug="schedules" label="My Audit Schedules" spaced icon={<FaRegCalendar size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                        <MenuItemLink slug="audits" label="My Audit Reports" spaced icon={<FaBookOpen size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                        <MenuItemLink slug="licenses" label="My Licenses" spaced icon={<FaStamp size={16} color={`#666`}/>} closeSidebar={() => setSidebar(false)} />
                    </>
                ) }
                
            </div>
            <div className="bg-white">
                <span className="flex-end text-xs text-gray-400 uppercase">
                    {`Status`}
                </span>
            </div>
          </div>
        </aside>
    </>
  )
}

const LinkDesk = ( { label = "Help Desk" } ) => {
    return (
        <div className="flex items-center mx-2 ring rounded-sm ring-gray-100">
            <div><FaLaptop size={12} color={`#666`} /></div>
            <div className="px-1 text-xs">
                {label}
            </div>
        </div>
    )
}

const MenuItemLink = ( { label, icon, spaced, slug, closeSidebar } ) => {
    const handleNavigate = async () => {
        if (window.innerWidth < 768 && closeSidebar) {
            closeSidebar()
        }
        await localStorage.setItem( "link", slug )
        return window.location.reload()
    }
    return (
        <button type="button" onClick={handleNavigate} className={`flex h-10 border-b border-gray-200 hover:bg-green-50 hover:font-bold hover:text-black ${ spaced ? "py-2" : "my-0" } `}>
            <div className="h-full w-full flex items-center">
                <span>{icon}</span>
                <span className="text-gray-500 text-xs md:text-xs lg:text-xs">{label}</span>
            </div>
            <div className="h-full flex items-center justify-center px-1">
                <span>
                    <FaAngleRight size={14} color={`#666`} />
                </span>
            </div>
        </button>
    )
}


const SidebarLink = ( { item, closeSidebar } ) => {
    const [ subnav, setSubNav ] = React.useState( false )

    const showSubNav = () => setSubNav( !subnav )

    const handlePress  = async slug => {
        if (window.innerWidth < 768 && closeSidebar) {
            closeSidebar()
        }
        await localStorage.setItem( "parent", slug[ 0 ] )
        await localStorage.setItem( "link", slug[ 1 ] )
        return window.location.reload()
    }

    return (
        <>
        <div onClick={item.subNav && showSubNav} className={`${localStorage.getItem( "parent" ) === item.slug ? "bg-[#252831] border-l-2 text-white flex justify-between items-center px-2 py-1 h-10 text-xs hover:bg-[#252831] hover:border-l-2 hover:text-white hover:cursor-pointer" : "text-black flex justify-between items-center px-2 py-1 h-10 text-xs hover:bg-[#252831] hover:border-l-2 hover:text-white hover:cursor-pointer" }`}>
            <div className="flex items-center justify-center">
                {item.icon}
                <div className="ml-4">{item.title}</div>
            </div>
            <div>
                {item.subNav &&  subnav ? item.iconOpened : item.subNav ? item.iconClosed : null }
            </div>
        </div>
        {subnav && item.subNav.map( ( val, index ) => {
            return (
                <div onClick={() =>handlePress( val.slug )} key={index} className={`${localStorage.getItem( "link" ) === val.slug[ 1 ] && "bg-gray-50 text-black font-bold"} bg-white h-10 border-b border-gray-300 flex items-center justify-start no-underline text-gray-500 text-xs hover:bg-[#DDD] hover:cursor-pointer`}>
                    {/* {val.icon} */}
                    <div className="text-start md:px-14 lg:px-14">{val.title}</div>
                </div>
            )
        }  )}
        </>
    )
}
